const sizesChartSizes = {
    XS: {
        width: '51.5 cm',
        height: '64 cm'
    },
    S: {
        width: '54.5 cm',
        height: '67.5 cm'
    },
    M: {
        width: '57.5 cm',
        height: '71 cm'
    },
    L: {
        width: '60.5 cm',
        height: '73 cm'
    },
    XL: {
        width: '63.5 cm',
        height: '75 cm'
    },
    XXL: {
        width: '66.5 cm',
        height: '77 cm'
    },
    '3XL': {
        width: '69.5 cm',
        height: '79 cm'
    }
}

function isTouchDevice() {
    return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
}

function initSizeChart(node) { 
    const id = $(node).attr('data-id')
    const sizeOverlay = $(node).parents('.product').find('.size-overlay')

    // set svg mask ids
    const svg = $(sizeOverlay).find('svg')
    const mask1 = svg.find('#maskHeight')
    const mask2 = svg.find('#maskWidth')
    const path1 = svg.find('#pathHeight')
    const path2 = svg.find('#pathWidth')
    mask1.attr('id','maskHeight-'+id)
    mask2.attr('id','maskWidth-'+id)
    path1.attr('mask','url(#maskHeight-'+id+')')
    path2.attr('mask','url(#maskWidth-'+id+')')

    const badgeHeight = $(sizeOverlay).find('#sizeBadgeHeight')
    const badgeWidth = $(sizeOverlay).find('#sizeBadgeWidth')
    const sizeSelect = $(node).find('.shopify-buy__option-select__select')

    const size = sizesChartSizes[$(sizeSelect).val()]
    $(badgeHeight).text(size.height)
    $(badgeWidth).text(size.width)

    function setAText() {
        const aText = sizeOverlay.hasClass('show') ? 'hide size' : 'show size'
        $(node).find('a.sizechart').text(aText)
    }
    setAText()

    $(node).find('a.sizechart').off('click').on('click', function(e) {

        e.preventDefault()

        sizeOverlay.toggleClass('show');

        if ('MatomoTracker' in window) {
            const productTitle = $(node).parents('.product').find('h2').text()
            const hideShow = sizeOverlay.hasClass('show') ? 'Show' : 'Hide'
            const eventMessage = hideShow + " (" + productTitle + ")"

            MatomoTracker.trackEvent('Sizes', eventMessage)
        }
        
        if (sizeOverlay.hasClass('show')) {
            let badgeHeightRect = badgeHeight[0].getBoundingClientRect()
            let badgeWidthRect = badgeWidth[0].getBoundingClientRect()

            const maskHeight = $(sizeOverlay).find('svg #clipHeight')
            const maskWidth = $(sizeOverlay).find('svg #clipWidth')

            function setMask() {
                const sizeOverlayRect = sizeOverlay[0].getBoundingClientRect()

                const relBadgeHeight = ((badgeHeightRect.height + 5) / sizeOverlayRect.height) * 100
                maskHeight.attr('height', relBadgeHeight+"%")

                const relBadgeWidth = ((badgeWidthRect.width + 5) / sizeOverlayRect.width) * 100
                maskWidth.attr('width', relBadgeWidth+"%")
            }

            function setBadgeHeight(cy) {
                let sizeOverlayRect = sizeOverlay[0].getBoundingClientRect()
                const relY = cy - (badgeHeightRect.height / 2) - sizeOverlayRect.y
                const limitYEnd = (relY + badgeHeightRect.height + 2.5 + 10) >= sizeOverlayRect.height
                const badgeY = (relY / sizeOverlayRect.height) * 100

                if (badgeY > 2 && !limitYEnd) {
                    badgeHeight.css('top',badgeY+"%")
                    maskHeight.attr('y',badgeY+"%")
                }
            }

            function setBadgeWidth(cx) {
                let sizeOverlayRect = sizeOverlay[0].getBoundingClientRect()
                const relX = cx - (badgeWidthRect.width / 2) - sizeOverlayRect.x
                const limitXEnd = (relX + badgeWidthRect.width+ 2.5 + 5) >= (sizeOverlayRect.width * 0.76)
                const badgeX = (relX / sizeOverlayRect.width) * 100
                if (badgeX > 24 && !limitXEnd) {
                    badgeWidth.css('left',badgeX+"%")
                    maskWidth.attr('x',badgeX+"%")
                }
            }

            setAText()

            if (isTouchDevice()) {
                setBadgeHeight(75)
                setBadgeWidth(35)
            } else {
                $(window).on('mousemove', function(e) {
                    const cx = e.clientX
                    const cy = e.clientY
    
                    let sizeOverlayRect = sizeOverlay[0].getBoundingClientRect()
    
                    if (cy > sizeOverlayRect.y && cy < (sizeOverlayRect.y + sizeOverlayRect.height)) {
                        setBadgeHeight(cy)
                    }
    
                    if (cx > sizeOverlayRect.x && cx < (sizeOverlayRect.x + sizeOverlayRect.width)) {
                        setBadgeWidth(cx)
                    }
                })
            }

            $(window).on('resize', function() {
                setTimeout(function() {
                    // sizeOverlayRect = sizeOverlay[0].getBoundingClientRect()
                    badgeHeightRect = badgeHeight[0].getBoundingClientRect()
                    badgeWidthRect = badgeWidth[0].getBoundingClientRect()

                    setMask()
                },200)
            })
            setMask()

            window.jump($(node).parents('.product')[0])
        } else {
            setAText()
            $(window).off('mousemove')
            $(window).off('resize')
        }
    })
}

module.exports = initSizeChart